<template>
  <div class="expert-detail">
    <div class="banner">专家·详情介绍</div>
    <div class="content">
      <a-breadcrumb>
        <span slot="separator">
          <img src="~@/assets/img/detail-arrow.svg" style="margin: 0 6px" />
        </span>
        <a-breadcrumb-item href="">
          <img src="~@/assets/img/home.png" class="home-class" />
          <span style="color: #333">首页</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <span style="color: #333">专家智库</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <span style="color: #7f7f7f">{{ tankDetail.fullName }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="personal-info">
        <div class="info-l">
          <img :src="tankDetail.image" class="info-img" />
          <div class="name">{{ tankDetail.fullName }}</div>
          <span class="unit">{{
            tankDetail.schoolDictDto && tankDetail.schoolDictDto.name
          }}</span>
        </div>
        <div class="info-r">
          <p>
            <em>出生日期</em
            ><span>{{ tankDetail.birthday ? tankDetail.birthday : "未知" }}</span>
          </p>
          <p>
            <em>民族</em><span>{{ tankDetail.nation }}</span>
          </p>
          <p>
            <em>性别</em><span>{{ tankDetail.sex }}</span>
          </p>
          <p>
            <em>学历</em><span>{{ tankDetail.education }}</span>
          </p>
          <p>
            <em>职称</em
            ><span>{{ tankDetail.titleGrade ? tankDetail.titleGrade : "未知" }}</span>
          </p>
          <p>
            <em>职业</em><span>{{ tankDetail.occupation }}</span>
          </p>
          <p>
            <em>研究方向</em><span>{{ tankDetail.direction }}</span>
          </p>
          <p>
            <em>担任职务</em><span>{{ tankDetail.userPosition }}</span>
          </p>
        </div>
      </div>
      <div class="personal-resume">
        <table>
          <caption class="table-title">
            个人履历
          </caption>
          <thead>
            <tr>
              <th>年份</th>
              <th>奖项</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) of tankDetail.personalResume" :key="index">
              <td>{{ item.year }}</td>
              <td>{{ item.content }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="personal-awards">
        <table>
          <caption class="table-title">
            获奖经历
          </caption>
          <thead>
            <tr>
              <th>年份</th>
              <th>奖项</th>
              <th>地点</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) of tankDetail.awardExperience" :key="index">
              <td>{{ item.year }}</td>
              <td>
                {{ item.content }}
              </td>
              <td>{{ item.address }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="personal-thesis">
        <table>
          <caption class="table-title">
            学术论文
          </caption>
          <thead>
            <tr>
              <th>年份</th>
              <th>题目</th>
              <th>刊物</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) of tankDetail.academicContribution" :key="index">
              <td>{{ item.year }}</td>
              <td>{{ item.content }}</td>
              <td>{{ item.address }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-for="(item, index) in tankDetail.publication" :key="index">
        <div class="workds-show">
          <h4 class="table-title">作品展示</h4>
          <img :src="item.image" alt="" />
        </div>
        <div class="workds-name">
          <h4 class="table-title">作品名称</h4>
          <p>{{ item.name }}</p>
        </div>
        <div class="workds-desc">
          <h4 class="table-title">作品描述</h4>
          <p>
            {{ item.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { artExpertTankDetail } from "@/api/ExpertThinkTank";
export default {
  name: "ExpertDetail",
  data() {
    return {
      id: "",
      tankDetail: {},
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.artExpertTankDetailFunc();
  },
  methods: {
    artExpertTankDetailFunc() {
      artExpertTankDetail(this.id)
        .then((res) => {
          let data = res.data;
          data.awardExperience = data.awardExperience && JSON.parse(data.awardExperience);
          data.academicContribution =
            data.academicContribution && JSON.parse(data.academicContribution);
          data.personalResume = data.personalResume && JSON.parse(data.personalResume);
          data.publication = data.publication && JSON.parse(data.publication);
          this.tankDetail = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.expert-detail {
  border-top: 1px solid #f2f2f2;
  position: relative;

  &::before,
  &::after {
    content: "";
    width: 228px;
    height: 439px;
    position: absolute;
    top: 273px;
    background: url("../../../assets/img/ExpertThinkTank-bg.png") no-repeat;
    background-size: 228px 439px;
    opacity: 0.37;
  }
  &::before {
    left: 0;
    transform: rotate(180deg);
  }
  &::after {
    right: 0;
  }
  .banner {
    margin-top: 8px;
    height: 260px;
    line-height: 260px;
    padding-left: 19.4vw;
    color: #fff;
    background: #2d3f51;
    font-size: 38px;
    text-align: left;
  }
  .content {
    margin: 0 auto;
    width: 1240px;
    background-color: #fff;
    .ant-breadcrumb {
      line-height: 14px;
      margin: 46px 0 33px;
    }
    .home-class {
      width: 14px;
      height: 14px;
      vertical-align: top;
      margin-right: 2px;
    }
    .personal-info {
      margin-bottom: 134px;
      width: 800px;
      display: flex;
      justify-content: space-between;
      .info-l {
        width: 224px;
        text-align: center;
        .info-img {
          width: 224px;
          height: 294px;
        }
        .name {
          margin-top: 36px;
          line-height: 31px;
          font-size: 31px;
          color: #333;
        }
        .unit {
          line-height: 45px;
          font-size: 21px;
          color: #7f7f7f;
        }
      }
      .info-r {
        width: 486px;
        p {
          margin-bottom: 12px;
          line-height: 23px;
          font-size: 15px;
          em {
            display: inline-block;
            width: 79px;
            color: #aaa;
            vertical-align: top;
          }
          span {
            display: inline-block;
            width: 406px;
            color: #555;
          }
        }
      }
    }
    .personal-resume {
      tr {
        th:nth-of-type(1),
        td:nth-of-type(1) {
          width: 226px;
        }
        th:nth-of-type(2),
        td:nth-of-type(2) {
          width: 1010px;
        }
      }
    }
    .personal-awards {
      tr {
        th:nth-of-type(1),
        td:nth-of-type(1) {
          width: 226px;
        }
        th:nth-of-type(2),
        td:nth-of-type(2) {
          width: 832px;
        }
        th:nth-of-type(3),
        td:nth-of-type(3) {
          width: 176px;
          text-align: right;
        }
      }
    }
    .personal-thesis {
      tr {
        th:nth-of-type(1),
        td:nth-of-type(1) {
          width: 226px;
        }
        th:nth-of-type(2),
        td:nth-of-type(2) {
          width: 832px;
        }
        th:nth-of-type(3),
        td:nth-of-type(3) {
          width: 176px;
          text-align: right;
          word-break: break-all;
        }
      }
    }
    .workds-show {
      img {
        width: 100%;
        height: auto;
        margin: 20px 0 30px;
      }
    }
    .workds-name,
    .workds-desc {
      p {
        margin: 20px 0 0;
        line-height: 21px;
        font-size: 15px;
        color: #333;
      }
    }
    .workds-name {
      margin-bottom: 50px;
    }
    .workds-desc {
      margin-bottom: 28px;
    }
    .table-title {
      margin: 0;
      padding: 0;
      line-height: 21px;
      font-size: 21px;
      color: #333;
      caption-side: top;
    }
    table {
      margin-bottom: 54px;

      thead {
        tr {
          th {
            display: inline-block;
            line-height: 71px;
            font-size: 19px;
            color: #2d3f51;
            font-weight: normal;
          }
        }
      }
      tbody tr {
        width: 100%;
        display: block;
        margin-bottom: 55px;
        font-size: 0;
        td {
          display: inline-block;
          line-height: 21px;
          font-size: 15px;
          color: #333;
          vertical-align: top;
        }
      }
    }
  }
}
</style>
